import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function InsertSigner(item) {
    return client.post("Signers/InsertSigner", item);
}
function GetAllSigners() {
  return client.get("Signers/GetAllSigners");
}

function UpdateSigner(item) {
  return client.put("Signers/UpdateSigner", item);
}

function DeleteSigner(id,uid, signerUid , newSignerUid = null ,  ) {
  var item = { id: id, commandUserId: uid, uId: signerUid, newSignerUid: newSignerUid,  };
  return client.delete("Signers", { data: item });
}

function CheckPendingApprovals(uid){
  return client.get("Signers/CheckPendingApprovals/" + uid)
}
function UpdateSignerStatus(item){
  return client.put("Signers/UpdateSignerStatus",item)
}

export{
    InsertSigner,
    GetAllSigners,
    UpdateSigner,
    CheckPendingApprovals,
    UpdateSignerStatus,
    DeleteSigner
}